import styled from 'styled-components';

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 40px;
  max-width: 1330px;
`;

export const TableHead = styled.thead`
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N500};
  height: 92px;
  text-align: left;
`;

export const TableHeader = styled.th`
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  color: ${(props) => props.theme.newPalette.neutral.N1000};
  padding-right: 60px;
  &:first-child {
    padding-right: 100px;
  }
  &:last-child {
    padding-right: 0;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N500};
  height: 142px;
`;

export const TableData = styled.td`
  ${(props) => props.theme.newTypography.textStyleBody}
  color: ${(props) => props.theme.newPalette.neutral.N1000};
  padding-right: 60px;
  &:first-child {
    padding-right: 100px;
  }
  &:last-child {
    padding-right: 0;
  }
`;
